/* Private preview: recent products stay in this browser, never sent to a service. */
(() => {
  if (customElements.get('amaro-search-history')) return;
  const key = 'amaro-ultra-recent-products-v1';
  const limit = 6;
  const maxAge = 30 * 24 * 60 * 60 * 1000;
  let memory = [];

  const clean = (entry) => {
    if (!entry || !/^\d+$/.test(String(entry.id)) || typeof entry.title !== 'string') return null;
    try {
      const url = new URL(entry.url, location.origin);
      if (url.origin !== location.origin || !/\/(?:products)\/[^/]+\/?$/.test(url.pathname)) return null;
      const viewed = Number(entry.viewed);
      if (!Number.isFinite(viewed) || viewed < Date.now() - maxAge || viewed > Date.now() + 60000) return null;
      let image = '';
      if (entry.image) {
        const candidate = new URL(entry.image, location.origin);
        if (candidate.protocol === 'https:' && (candidate.origin === location.origin || candidate.hostname === 'cdn.shopify.com')) image = candidate.href;
      }
      return {id: String(entry.id), title: entry.title.slice(0, 160), url: url.pathname, image, viewed};
    } catch (_) { return null; }
  };
  const read = () => {
    let value = memory;
    try { value = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) {}
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.map(clean).filter((entry) => {
      if (!entry || seen.has(entry.id)) return false;
      seen.add(entry.id);
      return true;
    }).slice(0, limit);
  };
  const write = (entries) => {
    memory = entries;
    try {
      if (entries.length) localStorage.setItem(key, JSON.stringify(entries));
      else localStorage.removeItem(key);
    } catch (_) {}
  };

  class AmaroSearchHistory extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-history-list]');
      this.empty = this.querySelector('[data-history-empty]');
      this.clearButton = this.querySelector('[data-clear-history]');
      if (!this.list || !this.empty || !this.clearButton) return;
      this.record();
      this.render();
      this.onClear = (event) => {
        if (!event.target.closest('[data-clear-history]')) return;
        write([]);
        this.render();
        this.querySelector('[data-history-status]').textContent = 'Historial borrado.';
        this.closest('search-drawer')?.querySelector('input[type="search"]')?.focus();
      };
      this.onStorage = (event) => { if (event.key === key || event.key === null) this.render(); };
      this.onPageShow = (event) => { if (event.persisted) { this.record(); this.render(); } };
      this.addEventListener('click', this.onClear);
      window.addEventListener('storage', this.onStorage);
      window.addEventListener('pageshow', this.onPageShow);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClear);
      window.removeEventListener('storage', this.onStorage);
      window.removeEventListener('pageshow', this.onPageShow);
    }
    record() {
      const entry = clean({id: this.dataset.productId, title: this.dataset.productTitle, url: this.dataset.productUrl, image: this.dataset.productImage, viewed: Date.now()});
      if (entry) write([entry, ...read().filter((item) => item.id !== entry.id)].slice(0, limit));
    }
    render() {
      const entries = read();
      this.list.replaceChildren();
      for (const entry of entries) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = entry.url;
        if (entry.image) {
          const image = document.createElement('img');
          image.src = entry.image;
          image.alt = '';
          image.width = 64;
          image.height = 64;
          image.loading = 'lazy';
          link.append(image);
        }
        const title = document.createElement('span');
        title.textContent = entry.title;
        link.append(title);
        item.append(link);
        this.list.append(item);
      }
      this.list.hidden = !entries.length;
      this.empty.hidden = Boolean(entries.length);
      this.clearButton.hidden = !entries.length;
    }
  }
  customElements.define('amaro-search-history', AmaroSearchHistory);
})();
